/**
 * paansreducer.js
 * Created by Vikas Gore on 14/08/2020.
 * manage the store user object
 */

import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

/**
 * This reducer function handles all the actions related to paans user user object.
 * @param {Object} state - A portion of the overall state which represents the user currently in memory.
 * @param {Object} action - Action object containing type and other values
 * @return {Object} - the currently paans policy accepted user
 */

export default function paansReducer(state = initialstate.paansuserdata, action) {
      switch (action.type) {
		case types.CHECK_USER_ACCEPTED_PAANS_POLICY:
			  return action.response;
		default:
			return state;
	}
}
